import { displayNumberWithComma } from '~/plugins/functions/display';
import {
  ModelQuotaOverallDetail,
  ModelQuotaDepartmentUsage,
  ModelUserQuota,
} from './quota.dto';
import type {
  IModelQuotaOverallDetailResponse,
  IModelQuotaDepartmentUsageResponse,
  IModelUserQuotaResponse,
} from './quota.dto';

export interface IModelSubDepartmentQuotaResponse {
  id: number;
  presetId: string | null;
  userId: string | null;
  presetVersionKey: string | null;
  name: string;
  type: string;
  quotaDepartmentId: string;
  parentId: string | null;
  createdAt: string | Date;
  updatedAt: string | Date;
  quotaDepartment: IModelQuotaOverallDetailResponse;
}

export class ModelSubDepartmentQuota {
  id: number;
  presetId: string | null;
  userId: string | null;
  presetVersionKey: string | null;
  name: string;
  type: string;
  quotaDepartmentId: string;
  parentId: string | null;
  createdAt: string | Date;
  updatedAt: string | Date;
  quotaDepartment: ModelQuotaOverallDetail;

  constructor(props = {} as IModelSubDepartmentQuotaResponse) {
    props = props ?? {};
    this.id = props.id || 0;
    this.presetId = props.presetId || null;
    this.userId = props.userId || null;
    this.presetVersionKey = props.presetVersionKey || null;
    this.name = props.name || '';
    this.type = props.type || '';
    this.quotaDepartmentId = props.quotaDepartmentId || '';
    this.parentId = props.parentId || null;
    this.createdAt = props.createdAt || '';
    this.updatedAt = props.updatedAt || '';
    this.quotaDepartment = new ModelQuotaOverallDetail(props.quotaDepartment || {});
  }
}

export interface IModelSubDepartmentListResponse {
  id: number;
  presetId: string | null;
  userId: string | null;
  presetVersionKey: string | null;
  name: string;
  type: string;
  quotaDepartmentId: string | null;
  parentId: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  subDepartmentQuota: IModelSubDepartmentQuotaResponse;
  quotaLimits: IModelQuotaDepartmentUsageResponse[];
  userQuotas: IModelUserQuotaResponse[];
  currentUsage: number;
  perDay: number;
  perMonth: number;
  conversationCount: number;
}

export class ModelSubDepartmentList {
  id: number;
  presetId: string | null;
  userId: string | null;
  presetVersionKey: string | null;
  name: string;
  type: string;
  quotaDepartmentId: string | null;
  parentId: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  subDepartmentQuota: ModelSubDepartmentQuota;
  quotaLimits: ModelQuotaDepartmentUsage[];
  userQuotas: ModelUserQuota[];
  currentUsage: string;
  perDay: string;
  perMonth: string;
  conversationCount: string;

  constructor(props = {} as IModelSubDepartmentListResponse) {
    props = props ?? {};
    this.id = props.id || 0;
    this.presetId = props.presetId || null;
    this.userId = props.userId || null;
    this.presetVersionKey = props.presetVersionKey || null;
    this.name = props.name || '';
    this.type = props.type || '';
    this.quotaDepartmentId = props.quotaDepartmentId || null;
    this.parentId = props.parentId || '';
    this.createdAt = props.createdAt || '';
    this.updatedAt = props.updatedAt || '';
    this.subDepartmentQuota = new ModelSubDepartmentQuota(props.subDepartmentQuota || {});
    this.quotaLimits = (props.quotaLimits || []).map(
      (e) => new ModelQuotaDepartmentUsage(e)
    );
    this.userQuotas = (props.userQuotas || []).map(
      (e) => new ModelUserQuota(e)
    );
    this.currentUsage = displayNumberWithComma(props.currentUsage || 0);
    this.perDay = displayNumberWithComma(props.perDay || 0);
    this.perMonth = displayNumberWithComma(props.perMonth || 0);
    this.conversationCount = displayNumberWithComma(props.conversationCount || 0);
  }
}
